export const FINANCIAL_PATH = "/apps/financial";

export const TRANSACTIONS_PATH = `${FINANCIAL_PATH}/transactions`;
export const getTransactionViewPath = (id: string | number) =>
  `${TRANSACTIONS_PATH}/view/${id}`;

export const REFUNDS_PATH = `${FINANCIAL_PATH}/refunds`;
export const getRefundViewPath = (id: string | number) =>
  `${REFUNDS_PATH}/view/${id}`;

export const RETURNS_PATH = `${FINANCIAL_PATH}/returns`;
export const getReturnViewPath = (id: string | number) =>
  `${RETURNS_PATH}/view/${id}`;

export const INVOICES_PATH = `${FINANCIAL_PATH}/invoices`;
export const getInvoiceViewPath = (id: string | number) =>
  `${INVOICES_PATH}/view/${id}`;

export const PAYOUTS_PATH = `${FINANCIAL_PATH}/payouts`;
export const getPayoutViewPath = (id: string | number) =>
  `${PAYOUTS_PATH}/view/${id}`;

export const CANCELLATION_POLICIES_PATH = `${FINANCIAL_PATH}/cancellation-policies`;
export const FEES_PATH = `${FINANCIAL_PATH}/fees`;
